import React, {useContext, useEffect, useState} from "react";
import Urls from "../utilis/api/Urls";
import Api from "../utilis/api/service";
import axios, {AxiosError, AxiosResponse} from "axios";
import LocalStorage from "../utilis/tools/LocalStorage";
import Info from "../utilis/tools/Info";
import {Link, Outlet, useLocation, useNavigate} from 'react-router-dom';
import branchInfo from "../utilis/models/branchInfo";
import AuthContext from "../utilis/contexts/AuthContext";
import AsredadeLogo from "../images/asredadehLogo.png"
import AbfaLogo from "../images/logobg.png"
import {Avatar, Button, Divider, Form, Input, Layout, Menu, Modal, notification} from "antd";
import {
    AimOutlined,
    AppstoreOutlined,
    BarcodeOutlined,
    DatabaseOutlined,
    HomeOutlined,
    PlusOutlined,
    ProfileOutlined,
    ShoppingOutlined,
    MonitorOutlined,
    DollarCircleOutlined
} from "@ant-design/icons";
import AppContext from "../utilis/contexts/AppContext";
import Texts from "../utilis/defaults/Text";
import {AddBranchValidation, Validation} from "../utilis/tools/validation";
import {ConvertPersianToEnglish} from "../utilis/helpers/convertor";
import ServiceCode from "../utilis/enums/ServiceCode";
import serviceCode from "../utilis/enums/ServiceCode";

const Panel = (props: any) => {
    const [form] = Form.useForm();
    const location=useLocation();
    const {Content, Sider} = Layout;
    const authContext = useContext(AuthContext);
    const appContext = useContext(AppContext);
    const navigate = useNavigate();
    const Token = LocalStorage.getToken();
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [ip,setIP]=useState<any>(null);
    const [countryInfo,setCountryInfo]=useState<any>(null);
    const [browser,setBrowser]=useState<any>(null);
    useEffect(()=>{
        if (ip){
            axios.get('https://geolocation-db.com/json/'+ip).then(response=>{
              try {
                  if(response.data){
                      setCountryInfo(response.data)
                      if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
                          setBrowser('Opera');
                      } else if (navigator.userAgent.indexOf("Edg") != -1) {
                          setBrowser('Edge');
                      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
                          setBrowser('Chrome');
                      } else if (navigator.userAgent.indexOf("Safari") != -1) {
                          setBrowser('Safari');
                      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
                          setBrowser('Firefox');
                      } else {
                          setBrowser('-');
                      }
                  }
              }catch {

              }
            }).catch(error=>{
                console.log()
            })
        }
    },[ip]);
    const handleNavigate = (path: string) => {
        const noDeptAffect = [
            serviceCode.TemporaryDisconnectAndConnectBranch,
            serviceCode.SaleTankerWater,
            serviceCode.WaterBranchAssignment,
            ServiceCode.BillingReview,
            ServiceCode.MidTermBill,
            ServiceCode.DeclareMeterConsumption];

        let isContain = false;
        Object.values(noDeptAffect).forEach((item: ServiceCode) => {
            if (item.toString() === path) {
                isContain = true;
            }
        })
        if (!isContain && authContext.currentBranchInfo.has_debt) {
            notification['error']({
                message: '',
                description: authContext.currentBranchInfo.debt_message,
                duration: 120
            });


        } else {
            navigate(`/panel/${path}`, {
                state: {
                    hasRefresh: true,
                }
            })
        }

    }
    if (!authContext.authenticated) {
        navigate('/login')
    }
    useEffect(() => {
        axios.get('https://api.ipify.org/?format=json').then(response=>{
            if(response.data && response.data.ip){
                setIP(response.data.ip)
            }
        })
        if (Token) {
            appContext.handleLoading(true)
            Api.post(Urls.getBranchInfo, {
                Cellphone: authContext?.user?.cellphone,
                FileNumber: authContext.currentFileNumber
            }, {
                headers: {
                    "Authorization": Token.token_type + " " + Token.access_token
                }
            }).then((response: AxiosResponse) => {

                const {data} = response;
                const {Data} = data;
                const {branches, branch_info} = Data;
                authContext.handleCurrentBranchInfo(branch_info)
                authContext.handleData(branch_info)
                authContext.handleBranches(branches)
                LocalStorage.setBranchInfo(branch_info);
            }).catch((e: AxiosError) => {

            }).finally(() => {

                appContext.handleLoading(false)


            })
        }

    }, [authContext.currentFileNumber])

    const showAddBranchModal = () => {
        authContext.handleAddBranchModal(true)
    };
    const handleCloseModal = () => {
        authContext.handleAddBranchModal(false);
    }
    const addBranch = (values: any) => {
        setConfirmLoading(true);

        Api.post(Urls.BranchInquiry, {
            Cellphone: authContext.user.cellphone,
            FileNumber: ConvertPersianToEnglish(values.FileNumber),
            Alias: ConvertPersianToEnglish(values.FileNumber)
        }, {
            headers: {

                "Authorization": Token.token_type + " " + Token.access_token
            }
        }).then((response: AxiosResponse) => {
            const {data} = response;
            const {Status, Message, Data} = data;
            if (Status === 0) {
                authContext.handleCurrentBranchInfo(Data.branch);
                authContext.handleCurrentFileNumber(Data.branch.file_number);
                LocalStorage.setFileNumber(Data.branch.file_number);


            }
            if (Status === -1) {

                notification['error']({
                    message: Message,
                    duration: 120
                });
            }
        }).catch((e: AxiosError) => {

        }).finally(() => {
            handleCloseModal();
            form.resetFields()
            setConfirmLoading(false)
        })

    };

    useEffect(() => {
        if (authContext.authenticated) {
            const cellphone = authContext.user.cellphone
            appContext.handleLoading(true)
            Api.post(Urls.getAccessToken, {Cellphone: cellphone}, {
                headers: {
                    "Authorization": `Basic ${btoa(cellphone + ":" + LocalStorage.getDeviceId())}`,
                    "Os-Name": Info.deviceInfo.realOsName,
                    "Os-Version-Name": Info.deviceInfo.osVersion,
                    "Os-Version-Code": Info.deviceInfo.osVersion + "11",
                    "Device-Id": LocalStorage.getDeviceId(),
                    "Device-Name": Info.deviceInfo.osName,
                    "Package-Name": Info.applicationInfo.packageName,
                    "Download-Source": Info.applicationInfo.downloadSource,
                    "App-Version-Name": Info.applicationInfo.appVersionName,
                    "App-Version-Code": Info.applicationInfo.appVersionCode,
                }


            }).then(({data, status}: AxiosResponse) => {
                const {Data, Status, Message} = data;
                if (Status === 0) {
                    authContext.handleAccessToken(Data.token);
                    LocalStorage.setToken(Data.token);
                    Api.post(Urls.getBranchInfo, {
                        Cellphone: cellphone,
                        FileNumber: authContext.currentFileNumber
                    }, {
                        headers: {
                            "Authorization": Data.token.token_type + " " + Data.token.access_token
                        }
                    }).then((response: AxiosResponse) => {

                        const {data} = response;
                        const {Data} = data;
                        const {branches, branch_info} = Data;
                        authContext.handleCurrentBranchInfo(branch_info)
                        authContext.handleData(branch_info)
                        authContext.handleBranches(branches)
                    }).catch((e: AxiosError) => {

                    }).finally(() => {
                        appContext.handleLoading(false)
                    })
                } else {
                    notification['error']({
                        message: Message,

                        duration: 3
                    });
                    setTimeout(() => {
                        authContext.logout();
                    }, 3000)
                }
            }).catch((e: AxiosError) => {
                appContext.handleLoading(false)
            }).finally(() => {

            })
        } else {
            navigate('/login')
        }

    }, []);

    if (!authContext.authenticated) {
        navigate('/login')
        return null
    }
    const handleBranchInfo = (fileNum: string, redirect: boolean) => {

        appContext.handleLoading(true)
        Api.post(Urls.getBranchInfo, {
            Cellphone: authContext.user.cellphone,
            FileNumber: fileNum
        }, {
            headers: {
                "Authorization": authContext.Token.tokenType + " " + authContext.Token.accessToken
            }
        }).then((response: AxiosResponse) => {

            const {data} = response;
            const {Data, Status} = data;
            const {branches, branch_info} = Data;
            if (Status === 0) {
                LocalStorage.setFileNumber(fileNum);
                authContext.handleCurrentFileNumber(fileNum)
                authContext.handleCurrentBranchInfo(Object.keys(branch_info).length === 0 ? new branchInfo() : branch_info)
                authContext.handleBranches(branches)
                authContext.handleCurrentFileNumber(fileNum)
                navigate('/panel')
            }

        }).catch((e: AxiosError) => {

        }).finally(() => {
            appContext.handleLoading(false)
        })

    }
    if(location.pathname.includes('/panel/letter')){
        return    <Outlet />
    }
    return <Layout className="bg-white">
        <Layout className="bg-white items-start rounded" style={{padding: '0 24px 24px'}}>
            <Sider theme="light" width={250} className="hidden lg:block rounded-lg overflow-hidden   mb-3  ml-5">
                <div className="w-full  flex justify-center p-3 items-center flex-col ">
                    <Avatar className="mb-3" size="large">{authContext.user.name.charAt(0)}</Avatar>
                    <div className="flex justify-center mt-2 items-center flex-col">
                        <span className="font-12">{authContext.user.name}</span>
                        <span className="font-12">{authContext.user.cellphone}</span>
                        <Button danger type="primary" onClick={() => authContext.logout()} className="mt-2 px-5 py-2"
                                size="small">خروج</Button>
                    </div>
                    <Divider orientation="center" type="horizontal" orientationMargin={1}/>
                </div>

                <Menu
                    mode="inline"
                    defaultSelectedKeys={['1']}
                    defaultOpenKeys={['sub1']}
                    style={{borderRight: 0}}

                >
                    <Menu.Item key={"home"}>
                        <Link to={'/panel/'}>
                            <HomeOutlined/>
                            <span>صفحه اصلی</span>
                        </Link>
                    </Menu.Item>

                    <Menu.SubMenu
                        key={"sub-1"}
                        title={
                            <>
                                <BarcodeOutlined/>
                                <span>اشتراک ها</span>
                            </>
                        }

                    >
                        <Menu.Item key={"new-branch"} onClick={showAddBranchModal}>
                            <PlusOutlined/>
                            <span>افزودن اشتراک</span>
                        </Menu.Item>
                        {
                            authContext.branches.map((branch: any, index) => <Menu.Item
                                className={branch.file_number === authContext.currentFileNumber ? 'ant-menu-item-selected' : ''}
                                onClick={() => handleBranchInfo(branch.file_number, true)} key={index + "new-branch"}>

                                <span>{branch.file_number}</span>
                            </Menu.Item>)
                        }

                    </Menu.SubMenu>
                    <Menu.SubMenu
                        key={"sub-2"}
                        title={
                            <>
                                <AppstoreOutlined/>
                                <span> خدمات  ۲۴ گانه</span>
                            </>
                        }

                    >

                        {authContext.currentFileNumber && authContext.currentFileNumber !== "" && <>
                            <Menu.Item key={Texts.ReplyToInquiry}
                                       onClick={() => handleNavigate(ServiceCode.ReplyToInquiry)}>
                                <span>{Texts.ReplyToInquiry}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.ChangeAccountType}
                                       onClick={() => handleNavigate(ServiceCode.ChangeAccountType)}>
                                <span>{Texts.ChangeAccountType}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.ChangeSpecifications}
                                       onClick={() => handleNavigate(ServiceCode.ChangeSpecifications)}>
                                <span>{Texts.ChangeSpecifications}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.ChangeUnit}
                                       onClick={() => handleNavigate(ServiceCode.ChangeUnit)}>
                                <span>{Texts.ChangeUnit}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.ChangeCapacityContractualBranching}
                                       onClick={() => handleNavigate(ServiceCode.ChangeCapacityContractualBranching)}>
                                <span>{Texts.ChangeCapacityContractualBranching}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.ChangeBranchDiameter}
                                       onClick={() => handleNavigate(ServiceCode.ChangeBranchDiameter)}>
                                <span>{Texts.ChangeBranchDiameter}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.MeterSeparation}
                                       onClick={() => handleNavigate(ServiceCode.MeterSeparation)}>
                                <span>{Texts.MeterSeparation}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.MoveMeasuringDevices}
                                       onClick={() => handleNavigate(ServiceCode.MoveMeasuringDevices)}>
                                <span>{Texts.MoveMeasuringDevices}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.MeterTest}
                                       onClick={() => handleNavigate(ServiceCode.MeterTest)}>
                                <span>{Texts.MeterTest}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.MeterChange}
                                       onClick={() => handleNavigate(ServiceCode.MeterChange)}>
                                <span>{Texts.MeterChange}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.InstallAdditionalSiphon}
                                       onClick={() => handleNavigate(ServiceCode.InstallAdditionalSiphon)}>
                                <span>{Texts.InstallAdditionalSiphon}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.TemporaryDisconnectAndConnectBranch}
                                       onClick={() => handleNavigate(ServiceCode.TemporaryDisconnectAndConnectBranch)}>
                                <span>{Texts.TemporaryDisconnectAndConnectBranch}</span>
                            </Menu.Item>

                            <Menu.Item key={Texts.MidTermBill}
                                       onClick={() => handleNavigate(ServiceCode.MidTermBill)}>
                                <span>{Texts.MidTermBill}</span>
                            </Menu.Item>

                            <Menu.Item key={Texts.CollectOrMergeBranch}
                                       onClick={() => handleNavigate(ServiceCode.CollectOrMergeBranch)}>
                                <span>{Texts.CollectOrMergeBranch}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.BillingReview}
                                       onClick={() => handleNavigate(ServiceCode.BillingReview)}>
                                <span>{Texts.BillingReview}</span>
                            </Menu.Item>

                            <Menu.Item key={Texts.DeclareMeterConsumption}
                                       onClick={() => handleNavigate(ServiceCode.DeclareMeterConsumption)}>
                                <span>{Texts.DeclareMeterConsumption}</span>
                            </Menu.Item>




                            <Menu.Item key={Texts.WasteWaterBranchAssignment}
                                       onClick={() => handleNavigate(ServiceCode.WasteWaterBranchAssignment)}>
                                <span>{Texts.WasteWaterBranchAssignment}</span>
                            </Menu.Item>


                        </>}

                        <Menu.Item key={Texts.SaleTankerWater}
                                   onClick={() => handleNavigate(ServiceCode.SaleTankerWater)}>
                            <span>{Texts.SaleTankerWater}</span>
                        </Menu.Item>
                        <Menu.Item key={Texts.WaterBranchAssignment}
                                   onClick={() => handleNavigate(ServiceCode.WaterBranchAssignment)}>
                            <span>{Texts.WaterBranchAssignment}</span>
                        </Menu.Item>
                        <Menu.Item key={Texts.WaterBranchAssignment}
                                   onClick={() => {
                                       window.open('http://195.181.42.3:9084/', '_blank')
                                   }
                                   }>
                            <span>{Texts.Accidents}</span>
                        </Menu.Item>
                    </Menu.SubMenu>

                    {authContext.currentFileNumber && authContext.currentFileNumber !== "" && <Menu.Item key={"bills"}>
                        <Link to={'/panel/bills'}>

                            <ProfileOutlined/>
                            <span>لیست قبض ها</span>
                        </Link>
                    </Menu.Item>}
                    {authContext.currentFileNumber && authContext.currentFileNumber !== "" &&
                        <Menu.Item key={"payments"}>
                            <Link to={'/panel/paymentHistory'}>
                                <ShoppingOutlined/>
                                <span>لیست پرداخت ها</span>
                            </Link>
                        </Menu.Item>}
                    <Menu.Item key={"manageFiles"}>
                        <Link to={'/panel/manageFiles'}>
                            <DatabaseOutlined/>
                            <span>مدیریت پرونده ها</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={"myRequests"}>
                        <Link to={'/panel/myRequests'}>
                            <AimOutlined/>
                            <span>درخواست های من</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={"findWorkFlow"}>
                        <Link to={'/panel/findWorkFlow'}>
                            <MonitorOutlined/>
                            <span>پیگیری درخواست</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={"myTransactions"}>
                        <Link to={'/panel/MyTransactions'}>
                            <DollarCircleOutlined/>
                            <span>تراکنش های من</span>
                        </Link>
                    </Menu.Item>
                    {/* <Menu.Item key={"myTransactions"} >
                        <Link to={'/panel/myTransactions'}>
                            <AimOutlined />
                            <span>تراکنش های من</span>
                        </Link>
                    </Menu.Item>*/}
                </Menu>

                <div className="px-2 my-2  flex flex-col justify-end  items-end ">
                    {countryInfo && countryInfo?.country_name &&<div className="w-full bg-gray-150   flex justify-between text-left p-1 "><strong>کشور</strong><span>{countryInfo?.country_name}</span></div>}
                    {ip &&<div className="w-full bg-gray-100 text-left  flex justify-between   p-1"><strong>آی پی   </strong><span>{ip}</span></div>}
                    {countryInfo && countryInfo?.country_name &&<div  className=" flex justify-between   w-full bg-gray-150 text-left p-1 "><strong>مرورگر  </strong> <span>{browser}</span></div>}
                </div>
                <div className="">
                    <a className="border-t flex justify-center items-center  p-3" target="_blank"
                       href="https://asredade.com">
                        <img className="w-[25px] pl-2 h-auto" src={AsredadeLogo} alt=""/>
                        <small className="text-gray-600">تهیه و توسعه توسط شرکت <span
                            className="text-red-500">عصرداده</span> </small>
                    </a>
                </div>
            </Sider>
            <Content
                className="bg-white relative  rounded-lg"
                style={{
                    padding: 24,
                    margin: 0,
                }}
            >
                {/*                <img src={AbfaLogo} className="w-full h-auto  fixed w-[80%] right-[10%] lg:w-[40%] opacity-70 mx-auto right-[30%] transform -translate[50%]" alt=""/>*/}
                <Outlet context={{
                    openModal: showAddBranchModal
                }}/>
            </Content>
        </Layout>
        <Modal
            title="افزودن اشتراک"

            centered
            open={authContext.addBranchModalOpen}
            confirmLoading={confirmLoading}
            onCancel={handleCloseModal}
            footer={null}

        >
            <p className="  font-light mb-2 font-12">{Texts.addBranchDescription}</p>
            <Divider orientation="center" type="horizontal" orientationMargin={1}/>
            <Form
                form={form}
                name="basic"
                className="w-full mt-4 flex flex-col"
                layout='vertical'
                onFinish={addBranch}

                autoComplete="off" scrollToFirstError={true}
            >


                <Form.Item
                    label="لطفا شناسه قبض را وارد کنید"
                    name="FileNumber"

                    rules={[Validation(AddBranchValidation)]}
                >
                    <Input size="large"/>
                </Form.Item>


                <Form.Item className="w-full mt-5">
                    <Button size="large" type="default" onClick={handleCloseModal} className="ml-[1%] w-[48%]"
                            htmlType="button">
                        لغو
                    </Button>
                    <Button loading={confirmLoading} size="large" type="primary" className="bg-primary w-[48%] mr-[1%] "
                            htmlType="submit">
                        ثبت درخواست
                    </Button>
                </Form.Item>


            </Form>
        </Modal>
    </Layout>

}
export default Panel;